
<div class="newsCard"   (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
  <app-background-local #background ></app-background-local>
  <div class="global" >
    @if(currentNews){
      <div  *ngIf="!displayVideo" class="global image-container" [@imageContainerSlide]="{ value: imageContainerState, params: imageContainerAnimationParams }" >
        <div 
            [class.translateImgForSecondImage]="moveToTheLeft && hasSecondImage()"
            [@fadeInZoomSlowBig]="zoomIn ? 'in':'out'"  class="newsCardImage" [class.ratio-container]="isFirstImagePortrait"
            [style.background-image]="isFirstImagePortrait ? 'url(' + staticFirstImageUrl + ')' : ''" >
            @if(isFirstImagePortrait){
            <div class="blurry">
            </div>
            }
            <img [src]="getFirstImage(currentNews)" alt="" [class.keep-ratio]="isFirstImagePortrait" fallback="../assets/logo/defaultThumbnail.png"/> 
        </div>
        <div *ngIf="!videoIsPlaying && currentNews && currentNews.videoUrl !== null" class="playpause"></div>
        @if(currentNews && currentNews.image && currentNews.image.length > 1){
          <div id="secondImage" [class.translateAnimation]="moveToTheLeft"
            [style.background-image]="isSecondImagePortrait ? 'url(' + currentNews.image[1] + ')' : ''"
            [class.ratio-container]="isSecondImagePortrait"
          >
           @if(isSecondImagePortrait){
            <div class="blurry">
            </div>
            }
            <img 
              [src]="currentNews.image[1]" 
              alt="" 
              fallback="../assets/logo/defaultThumbnail.png"
              class="secondImage" [class.keep-ratio]="isSecondImagePortrait" />
          </div>
        }
      </div>
    }
    @if(currentNews && currentNews.videoUrl !== null){
      @if (sharedService.isYoutubeVideo(currentNews) && sharedService.isScriptLoaded()) {
         <app-videoplayer [style.visibility]="displayVideo ? 'visible' : 'hidden'"  class="videoPlayer" (finished)="youtubeClose($event)" [currentNews]="currentNews"></app-videoplayer>
      }
      @else if(!sharedService.isYoutubeVideo(currentNews)){
          <div class="video-container" [style.visibility]="displayVideo ? 'visible' : 'none'" [@fadeInZoomSlowBig]="displayVideo ? 'in':'out'">
              <video
                #videoLocal
                id="videoLocal"
                [src]="currentNews.videoUrl"
                class="video"
                preload="metadata"
                muted="true"
                (loadedmetadata)="onVideoMetadataLoaded()"
              ></video>
          </div>
        }
    }

  <div class="newsCardText" 
       *ngIf="currentNews" 
       [@newsCardAnimation]="showNewsCardText ? 'up' : 'down'"
     >
  <!-- Informations de publication (Auteur et Date) -->
  <div class="bandeau-haut">
    <div class="newsCardInfo">
      <p *ngIf="currentNews.date" class="newsCardAuthorDate">
        <span class="newsCardAuthor">{{ currentNews.authorName }}</span>
        <span class="newsCardSeparator">•</span>
        <span class="newsCardDate">{{ currentNews.date | datetimeFormat:'iso':currentLanguage }}</span>
      </p>
      <p *ngIf="currentNews.authorName && !currentNews.date" class="newsCardAuthorOnly">
        {{ currentNews.authorName }}
      </p>
    </div>
    <div class="tabs">    
      <svg class="tab__1" width="169" height="63.16" viewBox="0 0 169 63.16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g [attr.filter]="'url(#filter0_d_tab1)'">
          <path d="M158.333 51.335C142.835 51.335 136.323 38.785 132 28.5007L128.938 21.5014C126.938 17.5025 117.5 0.000564635 92 0H0V61.5H158.333V51.335Z" [attr.fill]="'#000000'"/>
        </g>
        <defs>
          <filter [attr.id]="'filter0_d_tab'" x="0" y="0" width="168.334" height="68.16" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset dx="6.67" dy="3.33"/>
            <feGaussianBlur stdDeviation="1.665"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" [attr.result]="'effect1_dropShadow_tab'"/>
            <feBlend mode="normal" in="SourceGraphic" [attr.in2]="'effect1_dropShadow_tab'" result="shape"/>
          </filter>
        </defs>
      </svg>
    </div>
  </div>
  <!-- Contenu de la carte -->
  <div class="newsCardContent" [style.background-color]="'#000000'">
    <!-- Titre -->
    <div class="newsCardTitle">
      <h1 [innerHTML]="currentNews.title"></h1>
    </div>
  </div>
  </div>
</div>
